import OptionsPanel from "./OptionsPanel.js"

export default class WindowOpacity extends OptionsPanel {

  constructor(props, context) {
    super(props, context)

    this.state.title = "Window Opacity" // TODO: This needs to be localized
    this.setting = "windowOpacity"
    this.listOptions = props.labels[this.setting]
    this.select()
  }

  static get contextTypes() {
    return super.contextTypes
  }

}
